module.exports = __webpack_public_path__ + "media/img/uploads/logo-peo-solider-4d351496b5a76e55aeb732801565c531.png";